import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trends22bis',
  templateUrl: './trends22bis.component.html',
  styleUrls: ['./trends22bis.component.css']
})
export class Trends22bisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
